import { Button, ButtonProps } from '@chakra-ui/react'
import { useFormikContext } from 'formik'

type BaseProps = {
  disabled?: boolean
  isLoading?: boolean
  loadingText?: string
}

export type SubmitButtonProps = ButtonProps & BaseProps;

export const SubmitButton: React.FC<SubmitButtonProps> = (
  props: SubmitButtonProps
) => {
  const { children, isLoading, loadingText, ...rest } = props
  const { isValid, handleSubmit } = useFormikContext()

  return (
    <Button
      disabled={!isValid || isLoading}
      onClick={() => handleSubmit()}
      isLoading={isLoading}
      loadingText={loadingText}
      minW={'50%'}
      {...rest}>
      {children}
    </Button>
  )
}

export default SubmitButton
